import { apiRequest } from "../util/apiUtils";
import auth0 from "auth0-js";

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE, // Optional: e.g., your API identifier
  responseType: "token id_token",
  scope: "openid profile email offline_access",
});

export const authLogin = async (payload) => {
  const { type, email, password, access_token } = payload;

  // if (type === "admin") {
  //   return await apiRequest("post", "admin-login", { body: payload });
  // }

  if (type === "admin") {
    const response = await apiRequest("post", "admin-login", { body: payload });
    return {
      status: response?.status,
      data: {
        ...response?.data,
        access_token: response?.data?.accessToken, // Normalize
      },
    };
  }

  if (type === "auth0" && access_token) {
    return await apiRequest("post", "third-signin", {
      body: { access_token },
    });
  }

  if (!email || !password) {
    return {
      status: 400,
      error: true,
      message: "Email and password are required",
    };
  }

  const data = {
    grant_type: "http://auth0.com/oauth/grant-type/password-realm",
    client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
    client_secret: process.env.REACT_APP_AUTH0_CLIENT_SECRET,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    scope: "openid profile email offline_access",
    realm: process.env.REACT_APP_AUTH0_REALM,
    username: email,
    password: password,
  };

  try {
    const response = await fetch(
      `https://${process.env.REACT_APP_AUTH0_DOMAIN}/oauth/token`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );

    const resJson = await response.json();

    if (!response.ok) {
      throw new Error(resJson.error_description || "Auth0 login failed");
    }

    return {
      status: 200,
      data: resJson,
    };
  } catch (err) {
    return {
      status: 400,
      error: true,
      message: err.message || "Unexpected login error",
    };
  }
};

// export const authLogin = async (payload) => {
//   try {
//     const res = await apiRequest(
//       "post",
//       payload?.type === "user"
//         ? `login`
//         : payload?.type === "admin" && "admin-login",
//       {
//         body: payload,
//       }
//     );

//     return res?.data;
//   } catch (err) {
//     return err;
//   }
// };

// export const authSignup = async (payload) => {
//   try {
//     const res = await apiRequest("post", "signup", {
//       body: payload,
//     });

//     return res?.data;
//   } catch (err) {
//     return err;
//   }
// };

export const authSignup = async (payload) => {
  const { email, password, firstName, lastName } = payload || {};

  if (!email || !password || !firstName || !lastName) {
    return {
      status: 400,
      error: true,
      message: "All fields are required",
    };
  }

  return new Promise((resolve) => {
    webAuth.signup(
      {
        connection: process.env.REACT_APP_AUTH0_REALM,
        email,
        password,
        given_name: firstName,
        family_name: lastName,
      },
      (err, result) => {
        if (err) {
          resolve({
            status: 400,
            error: true,
            message: err.description || "Signup failed",
          });
        } else {
          authLogin({ email, password }).then(resolve);
        }
      }
    );
  });
};

export const otpVerification = async (payload) => {
  try {
    const res = await apiRequest("post", "verify-otp", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const forgetPassword = async (payload) => {
  try {
    const res = await apiRequest("post", "reset-auth0", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const verifyAuthToken = async (payload) => {
  try {
    const res = await apiRequest("post", `verify-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const verifyShopifyAuth = async (payload) => {
  try {
    const res = await apiRequest("post", `shopify-callback`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

//after backend develop

// export const verifyAuthToken = async () => {
//   const token = localStorage.getItem("auth_token");

//   if (!token) return { data: { invalidToken: true } };

//   try {
//     // Step 1: Get user info from Auth0
//     const auth0User = await new Promise((resolve, reject) => {
//       webAuth.client.userInfo(token, (err, user) => {
//         if (err || !user?.sub) {
//           reject({ data: { invalidToken: true } });
//         } else {
//           resolve(user);
//         }
//       });
//     });

//     // Step 2: Call your backend verify-token endpoint
//     const backendRes = await apiRequest("post", "verify-token", {
//       body: {
//         auth0Id: auth0User.sub,
//         email: auth0User.email,
//       },
//     });

//     if (backendRes?.status !== 200 || !backendRes?.data?.data) {
//       return { data: { invalidToken: true } };
//     }

//     // Step 3: Combine both
//     const combinedUser = {
//       ...auth0User,
//       ...backendRes.data.data, // This includes roleCode, _id, etc.
//     };

//     return {
//       status: 200,
//       data: combinedUser,
//     };
//   } catch (err) {
//     return { data: { invalidToken: true } };
//   }
// };

// export const verifyAuthToken = async () => {
//   const token = localStorage.getItem("auth_token");

//   if (!token) return { data: { invalidToken: true } };

//   try {
//     const auth0User = await new Promise((resolve, reject) => {
//       webAuth.client.userInfo(token, (err, user) => {
//         if (err || !user?.sub) {
//           reject({ data: { invalidToken: true } });
//         } else {
//           resolve(user);
//         }
//       });
//     });

//     return {
//       status: 200,
//       data: {
//         ...auth0User,
//         roleCode: "USER", // mock fallback until verify-token works
//       },
//     };
//   } catch (err) {
//     return { data: { invalidToken: true } };
//   }
// };

export const tokenRefresh = async (payload) => {
  try {
    const res = await apiRequest("post", `refresh-token`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const resetPasswordRequest = async (payload) => {
  try {
    const res = await apiRequest("post", "user/reset-cred", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const sendOtp = async (payload) => {
  try {
    const res = await apiRequest("post", "send-otp", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const resetPasswordAccept = async (payload) => {
  try {
    const res = await apiRequest("post", "user/accept-reset-status", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const resendVerificationEmail = async (payload) => {
  try {
    const res = await apiRequest("post", "send-verify-email-auth0", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
export const changePassword = async (payload) => {
  try {
    const res = await apiRequest("post", "/change-password-auth0", {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
